import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, Table, Td, Empty, fmt } from "./AdminKit";

export default function AdminActivityLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { http.get("/v1/admin/activity-log").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="admin-activity-log">
      <h1 className="text-2xl font-bold text-white">Журнал активности</h1>
      <Panel title={`Записей: ${rows.length}`}>
        {rows.length === 0 ? <Empty /> : (
          <Table head={["Действие", "Объект", "Детали", "Дата"]}>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-700/50">
                <Td>{r.action}</Td>
                <Td>{r.entity}</Td>
                <Td>{r.details}</Td>
                <Td>{fmt(r.created_at)}</Td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
